import {
  ADD_REMINDER_SUCCESS,
  ARCHIVE_REMINDER_SUCCESS,
  DELETE_REMINDER_SUCCESS,
  GET_REMINDERS_SUCCESS,
  UNARCHIVE_REMINDER_SUCCESS,
  UPDATE_REMINDER_SUCCESS,
} from 'actions';
import { DateTime } from 'luxon';
import Company from 'models/Company';
import Contact from 'models/Contact';
import { Model, ModelType, attr, fk } from 'redux-orm';

interface IReminder {
  id: string;
  accountId: string;
  alarms: number[];
  alarmSubscribers: string[];
  archived: boolean;
  companyId: string;
  contactId: string;
  due: string;
  notes: string;
  organizerId: string;
  summary: string;
  timestamp: string;
  commitStamp: string;
}

class Reminder extends Model<typeof Reminder, IReminder> {
  id!: string;

  accountId!: string;

  alarms!: number[];

  alarmSubscribers!: string[];

  archived!: boolean;

  companyId!: Company;

  contactId!: Contact;

  due!: string;

  notes!: string;

  organizerId!: string;

  summary!: string;

  timestamp!: string;

  commitStamp!: string;

  static reducer(action: any, model: ModelType<Reminder>) {
    // eslint-disable-next-line default-case
    switch (action.type) {
      case GET_REMINDERS_SUCCESS:
        action.data.map((r: IReminder) => model.upsert(r));
        break;

      case ADD_REMINDER_SUCCESS:
        model.upsert({ ...action.data, archived: false });
        break;

      case UPDATE_REMINDER_SUCCESS:
        model.upsert(action.data);
        break;

      case ARCHIVE_REMINDER_SUCCESS:
        model.withId(action.id)?.update({ archived: true });
        break;

      case UNARCHIVE_REMINDER_SUCCESS:
        model.withId(action.id)?.update({ archived: false });
        break;

      case DELETE_REMINDER_SUCCESS:
        model.withId(action.id)?.delete();
        break;
    }

    return undefined;
  }

  toString() {
    return `Reminder: ${this.id}`;
  }

  toViewModel() {
    const due = DateTime.fromISO(this.due);
    const alarmTimestamps = this.alarms.map((minutes) =>
      due.plus({ minutes }).toISO(),
    );

    return {
      ...this.ref,
      contact: this.contactId ? this.contactId.toViewModel() : null,
      company: this.companyId ? this.companyId.toViewModel() : null,
      alarmTimestamps,
      alarm: alarmTimestamps.length > 0 ? alarmTimestamps[0] : null,
    };
  }
}

Reminder.modelName = 'Reminder';

Reminder.fields = {
  id: attr(),
  accountId: attr(),
  alarms: attr(),
  alarmSubscribers: attr(),
  archived: attr(),
  companyId: fk('Company'),
  due: attr(),
  notes: attr(),
  organizerId: attr(),
  summary: attr(),
  timestamp: attr(),
  contactId: fk('Contact'),
};

export type ReminderViewModel = ReturnType<Reminder['toViewModel']>;

export default Reminder;
